export default __webpack_public_path__ + "static/media/Elec14.6492607f.png";